var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { useTrusteeContext } from '../../../context';
import { Breadcrumbs, } from '../../../../components/breadcrumbs';
import Confirm from '../../../../common/views/remove/confirm/confirm';
import { cardType, cardTypeName } from '../../../../common/interfaces';
var getBreadcrumbLinks = function (_a) {
    var link1 = _a.link1, link2 = _a.link2;
    return [
        {
            to: 'BACK',
            underline: true,
            name: link1,
        },
        {
            name: link2,
            disabled: true,
        },
    ];
};
export var ConfirmRemove = function () {
    var _a, _b;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useTrusteeContext(), current = _d.current, send = _d.send, onRemove = _d.onRemove, i18n = _d.i18n;
    var breadcrumbLinks = getBreadcrumbLinks((_b = (_a = i18n === null || i18n === void 0 ? void 0 : i18n.remove) === null || _a === void 0 ? void 0 : _a.confirm) === null || _b === void 0 ? void 0 : _b.breadcrumbs);
    var _e = current.context, trustee = _e.trustee, remove = _e.remove;
    var handleRemove = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            onRemove(__assign({ schemeRoleId: trustee.schemeRoleId, effectiveDate: trustee.effectiveDate }, remove), trustee)
                .then(function () {
                setLoading(false);
                send('DELETE');
            })
                .catch(function () {
                setLoading(false);
            });
            return [2];
        });
    }); };
    return (React.createElement(Confirm, { cardType: cardType.actuary, cardTypeName: cardTypeName.actuary, breadcrumbs: function () { return React.createElement(Breadcrumbs, { links: breadcrumbLinks, send: send }); }, removeTitle: i18n.remove.confirm.title, removeMessage1: i18n.remove.confirm.subtitle, removeBtnTitle: i18n.remove.confirm.buttons.remove, cancelBtnTitle: i18n.remove.confirm.buttons.cancel, handleRemove: handleRemove, handleCancel: function () { return send('CANCEL'); }, loading: loading }));
};
//# sourceMappingURL=index.js.map